import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => ({
    container: {
        flexGrow: 1,
        overflowX: 'hidden',
        padding: theme.spacing(3),
        width: '100%',
    },
}));
export function Content({ children, className = '' }) {
    const classes = useStyles();
    return (_jsx("main", { className: clsx(classes.container, className), "data-testid": 'main-content', children: children }));
}
